import { render, staticRenderFns } from "./edit.pages.page.vue?vue&type=template&id=7c710ea1&"
import script from "./edit.pages.page.vue?vue&type=script&lang=js&"
export * from "./edit.pages.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports